(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/assets/javascripts/views/prolongation-page.js') >= 0) return;  svs.modules.push('/modules/lotto/assets/javascripts/views/prolongation-page.js');

'use strict';

svs.lotto.views.ProlongationPage = Marionette.View.extend({
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'lotto',
    component: 'prolongation'
  }],
  regions: {
    prolongationRegion: '#ngProlongationRegion'
  },
  template() {
    return svs.lotto.templates.prolongation_page();
  },
  onRender() {
    if (svs.lotto.components.prolongation) {
      this.showChildView('prolongationRegion', new svs.lotto.components.prolongation.views.Prolongation());
    }
  }
});

 })(window);